import { Component, OnInit, Input } from '@angular/core';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { Stand } from 'src/app/entity/Stand';
import { Client } from 'src/app/entity/exhibitor';
import { Subscription } from 'rxjs';




@Component({
  selector: 'app-client-contructeurs',
  templateUrl: './client-contructeurs.component.html',
  styleUrls: ['./client-contructeurs.component.css']
})
export class ClientContructeursComponent implements OnInit {

  @Input()
  prestatairesClientList: Client[];
  @Input()
  clientId: number;
  subscriptionStands: Subscription;


  constructor(private exhibitorService: ExhibitorService) { }

  ngOnInit() {

 
 
    this.subscriptionStands = this.exhibitorService.getSelectedConstructeur().subscribe(result => {
      this.prestatairesClientList = result;
  });
  }
  async remove(stand: Stand) {

    await this.exhibitorService.updateStands(this.clientId, stand.idStand, false);

    this.exhibitorService.subscribeConstructeurClient(this.clientId);
  }
}
